import React from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import RenderTextField from '../../form-controls/RenderTextField';
import { OutlinedTextFields } from '../../../components/material-textField/texField';
import { change, Field, untouch } from 'redux-form';
import PropTypes from 'prop-types';
import { r_maxLength } from '../../../utils/validation/restrictions';
import {
  CARD_SUPPORTED_ROUTING_CODE,
  DEVICE_MOBILE,
  VISA_TNC_LINK,
  VISA_FAQ_LINKS
} from '../../../utils/constants';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  cardExpiryValidation,
  visaDebitCardNoValidation,
  required
} from '../../../utils/validation';
import { saveNewBenificiary } from '../../../redux/actions/individual-user-flow/individual-user-flow-action';
import { encryptDataWithSignature } from '../../../utils/library';
import { replaceRecipientListItem } from '../../../redux/actions/transaction/transaction-action';
import { getBeneficiaryByID } from '../../../redux/actions/common/common-action';
import { Link } from 'react-router-dom';
import { setCardNumberUpdate } from '../../../redux/actions/payee-data/payee-data-action';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import some from 'lodash/some';
import sortBy from 'lodash/sortBy';
import {
  Title,
  StyledGrid,
  ButtonContainer,
  FastFundImage,
  VisaImage,
  LabelText,
  SaveButton,
  CardMessageContainer,
  FieldContainer,
  TNCText,
  FAQText,
  EditText
} from './bankdetails.styled';
import {
  CORRECT_ICON,
  EDIT_ICON,
  EDIT_ICON_MULTI_TXN_ICON,
  STOPWATCH_ICON,
  VISA_ICON,
  VISA_SVG_ICON
} from '@Images';

const FieldContainerNonSG = styled.div`
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  ${(props) => props.style}
  .render-text-field-edit {
    width: 100%;
  }
`;
const CardMessageContainerNonSG = styled.div`
  font-size: 12px;
  color: #4c890d;
  margin-top: 10px;
`;
const SaveButtonNonSG = styled.button`
  background-color: ${({ bgColor }) => (bgColor ? bgColor : '#009adf')};
  color: ${({ color }) => (color ? color : '#fff')};
  border-radius: 15px;
  padding: 10px;
  text-align: center;
  border: none;
  height: 35px;
  align-self: center;
  grid-column: 2/3;
  cursor: pointer;
  min-width: 140px;
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
const LabelTextNonSG = styled.div`
  color: #a9a9a9;
  font-size: 12px;
  margin-top: 20px;
  ${(props) => props.style}
`;
const VisaImageNonSG = styled.img`
  width: 25px;
  height: 12px;
  margin-top: 2px;
  ${(props) => props.style}
`;

const FastFundImageNonSG = styled.img`
  margin-right: 5px;
  ${(props) => props.style};
`;

const FragementNew = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

const ButtonContainerNonSG = styled.div`
  grid-column: 1 / 3;
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '0px')};
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
`;

const StyledGridNonSG = styled(Grid.Column)`
  grid-column: 1/3;
`;
class CardDetailsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderObject: null,
      reEnterLabel: null,
      debitCardFields: null,
      isDebitCardChecked: false,
      isBankChecked: false,
      isCardNumberUpdated: true
    };
  }
  fieldGenerator = (renderFields) => {
    let renderObject = [];
    let reEnterLabel = '';
    let fields = [];
    renderFields &&
      Object.keys(renderFields).forEach((key) => {
        let field = renderFields[key];
        if (field && field instanceof Object) {
          let obj = field.render;
          if (obj.value_field_name === 'bank_account_number') {
            reEnterLabel = obj.label;
          }
          renderObject.push(
            Object.assign({}, obj, {
              validation: {
                ...field.validation.length,
                required: field.validation.required
              }
            })
          );
        }
      });
    fields = renderObject.map((k) => k.value_field_name);
    this.props.getBankFields && this.props.getBankFields(fields);
    return {
      renderObject,
      reEnterLabel,
      fields
    };
  };

  resetOrEmptyGeneratedFields = (renderObject) => {
    renderObject.forEach((key) => {
      this.props.dispatch(change(this.props.formName, key.value_field_name, ''));
      this.props.dispatch(untouch(this.props.formName, key.value_field_name));
    });
  };
  async componentDidUpdate(prevProps) {
    let { debitCardFields, formValues } = this.props;
    if (
      debitCardFields &&
      JSON.stringify(prevProps.debitCardFields) !== JSON.stringify(this.props.debitCardFields)
    ) {
      let { renderObject: debitRenderObject, reEnterLabel: debitEnterLabel } = this.fieldGenerator(
        debitCardFields.BANK_DETAIL
      );
      await this.setState({
        debitRenderObject,
        debitEnterLabel,
        debitCardFields,
        isBankChecked: false,
        isDebitCardChecked: true
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', 'card'));
      this.props.dispatch(
        change(this.props.formName, 'card_type', get(debitCardFields, 'routing_config_type'))
      );
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.debit_validations)
      );
    }
    if (formValues && formValues.card_number !== prevProps.formValues.card_number) {
      this.props.dispatch(change(this.props.formName, 'fast_fund_message', ''));
      this.props.dispatch(change(this.props.formName, 'show_visa_icon', ''));
    }
  }

  componentDidMount = async () => {
    let { debitCardFields, isPartiallyEditable, isCompleteEditable } = this.props;
    if (debitCardFields) {
      let { renderObject: debitRenderObject, reEnterLabel: debitEnterLabel } = this.fieldGenerator(
        debitCardFields.BANK_DETAIL
      );
      if (CARD_SUPPORTED_ROUTING_CODE.includes(this.props.formValues.routing_config_type)) {
        debitRenderObject = debitRenderObject.map((debitRender) => ({
          ...debitRender,
          ...{ disabled: true }
        }));
        if (isPartiallyEditable || isCompleteEditable) {
          this.setState({ isCardNumberUpdated: false });
          this.props.dispatch(change(this.props.formName, 'is_card_number_updated', false));
        }
      }
      await this.setState({
        debitRenderObject,
        debitEnterLabel,
        debitCardFields,
        isBankChecked: false,
        isDebitCardChecked: true
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', 'card'));
      this.props.dispatch(
        change(this.props.formName, 'card_type', get(debitCardFields, 'routing_config_type'))
      );
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.debit_validations)
      );
      const isCardIssueNameExists = some(debitRenderObject, (item) => {
        return item.value_field_name === 'card_issuer_name';
      });
      if (!isCardIssueNameExists) {
        this.props.dispatch(change(this.props.formName, 'card_issuer_name', ''));
      }
    }
    if (CARD_SUPPORTED_ROUTING_CODE.includes(this.props.formValues.routing_config_type)) {
      this.setState({
        isBankChecked: false,
        isDebitCardChecked: true
      });
      this.props.dispatch(change(this.props.formName, 'details_selected', 'card'));
      this.props.dispatch(
        change(this.props.formName, 'bank_card_validations', this.props.debit_validations)
      );
      this.props.onTransferMoneyOptionChange && this.props.onTransferMoneyOptionChange(0);
    }
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    if (nextProps.debitCardFields) {
      if (!isEqual(nextProps.debitCardFields, this.props.debitCardFields)) {
        let { renderObject: debitRenderObject, reEnterLabel: debitEnterLabel } =
          this.fieldGenerator(nextProps.debitCardFields.BANK_DETAIL);
        this.resetOrEmptyGeneratedFields(debitRenderObject);
        await this.setState({
          debitRenderObject,
          debitEnterLabel,
          debitCardFields: nextProps.debitCardFields
        });
      }
    } else {
      await this.setState({
        debitRenderObject: null,
        debitEnterLabel: null,
        debitCardFields: null
      });
    }

    if (nextProps.currency_code !== this.props.currency_code) {
      let { renderObject, reEnterLabel } = this.fieldGenerator(nextProps.renderFields);
      this.resetOrEmptyGeneratedFields(renderObject);
      await this.setState({
        renderObject: renderObject,
        reEnterLabel: reEnterLabel
      });
    }
  };

  BankAccountCountryChange = (obj) => {
    this.props.dispatch(change(this.props.formName, 'routing_code_value_1', obj.value));
    this.props.dispatch(untouch(this.props.formName, 'routing_code_value_1', obj.value));
  };
  enableCardEdit = () => {
    this.setState(
      {
        isCardNumberUpdated: true
      },
      () => this.props.setCardNumberUpdate(true)
    );
    const { isPartiallyEditable, isCompleteEditable, debit_validations } = this.props;
    this.props.dispatch(change(this.props.formName, 'is_card_number_updated', true));
    this.props.dispatch(change(this.props.formName, 'fast_fund_message', ''));
    let debitRenderObject = this.state.debitRenderObject;
    debitRenderObject = debitRenderObject.map((key) => {
      let valueFieldName = key.value_field_name;
      if (isPartiallyEditable || isCompleteEditable) {
        this.setState({
          [`${valueFieldName}_backup`]: this.props.formValues[valueFieldName]
        });
      }
      let disabled = false;
      Object.keys(debit_validations).forEach((itemKey) => {
        if (
          isEqual(get(debit_validations[itemKey], 'render.value_field_name', ''), valueFieldName) &&
          debit_validations[itemKey].render.disabled
        ) {
          disabled = true;
        }
      });

      this.props.dispatch(change(this.props.formName, key['value_field_name'], ''));
      return { ...key, ...{ disabled: disabled, hideIcon: true } };
    });

    this.setState({
      debitRenderObject
    });
  };

  emptyCardIssuerName = () => {
    this.props.dispatch(change(this.props.formName, 'card_issuer_name', ''));
  };

  renderDebitCard = () => {
    const { debitRenderObject, isCardNumberUpdated } = this.state;
    const {
      formValues: { fast_fund_message = '', show_visa_icon },
      errors = {},
      fastFundsIndicator,
      featureState,
      device
    } = this.props;
    const toggleFeature = get(featureState, 'toggleFeature', false);
    const FieldContainerActual = toggleFeature ? FieldContainer : FieldContainerNonSG;
    const CardMessageContainerActual = toggleFeature
      ? CardMessageContainer
      : CardMessageContainerNonSG;
    const VisaImageActual = toggleFeature ? VisaImage : VisaImageNonSG;
    const FastFundImageActual = toggleFeature ? FastFundImage : FastFundImageNonSG;
    let cnyBankStyles = '';

    if (debitRenderObject) {
      // eslint-disable-next-line array-callback-return
      const debitCardRenderHtml = sortBy(debitRenderObject, ['sequence']).map((key, index) => {
        if (key.visible) {
          switch (key.type) {
            case 'text': {
              let isFieldDisabled = key.disabled || false;
              let validationArray =
                key['value_field_name'] === 'card_expiry_date'
                  ? [required, cardExpiryValidation]
                  : [required];
              if (
                key['value_field_name'] === 'card_number' &&
                this.props.formValues.card_type === 'VISA_DEBIT_CARD'
              ) {
                validationArray.push(visaDebitCardNoValidation);
              }
              if (toggleFeature) {
                if (key['value_field_name'] === 'card_issuer_name') {
                  cnyBankStyles = 'cnyFieldCase';
                } else if (key['label'].includes('Card Number')) {
                  cnyBankStyles = 'cnyBankCardNumberStyle';
                }
              }
              return (
                <Grid.Column
                  computer={this.props.isSingleRowField ? undefined : 7}
                  tablet={this.props.isSingleRowField ? undefined : 8}
                  mobile={this.props.isSingleRowField ? undefined : 16}
                  className={toggleFeature ? 'align-items-center' : ''}
                  style={this.props.isSingleRowField ? { width: '100%' } : undefined}
                  key={index}
                >
                  <FieldContainerActual
                    isSingleRowField={this.props.isSingleRowField}
                    style={{
                      borderBottom: `${!toggleFeature ? '1px solid #e0e0e0 !important' : ''}`
                    }}
                  >
                    {isFieldDisabled &&
                      !toggleFeature &&
                      key.value_field_name === 'card_number' &&
                      this.props.formValues.routing_config_type === 'VISA_DEBIT_CARD' && (
                        <VisaImageActual src={VISA_ICON} style={{ marginTop: 43, height: 15 }} />
                      )}
                    {toggleFeature ? (
                      <div
                        className={`${cnyBankStyles} ${
                          this.props.isSingleRowField ? 'fullWidthField' : ''
                        }`}
                      >
                        <Field
                          name={key['value_field_name']}
                          type="text"
                          className={'input form-flow disable_border'}
                          component={toggleFeature ? OutlinedTextFields : RenderTextField}
                          maxWidth={this.props.isSingleRowField ? '450px' : '325px'}
                          validate={isCardNumberUpdated ? validationArray : []}
                          disabled={isFieldDisabled}
                          placeholder={key.label}
                          isEditable={true}
                          onBlur={() => {
                            if (
                              key.value_field_name === 'card_number' &&
                              this.props.formValues.card_type === 'GEO_SWIFT_CARD'
                            ) {
                              this.emptyCardIssuerName();
                            }
                          }}
                          showErrorIcon={true}
                          isVisaCardEditCase={
                            isFieldDisabled &&
                            key['value_field_name'] === 'card_number' &&
                            this.props.formValues.routing_config_type === 'VISA_DEBIT_CARD'
                          }
                          normalize={(() => {
                            let { validation } = key;
                            if (validation) {
                              let { exact, max } = validation;
                              return r_maxLength(exact || max || 50);
                            }
                            return r_maxLength(50);
                          })()}
                        />
                        {key.value_field_name === 'card_number' &&
                          !errors['card_number'] &&
                          fast_fund_message &&
                          this.props.formValues.card_type === 'GEO_SWIFT_CARD' && (
                            <FastFundImageActual
                              src={CORRECT_ICON}
                              style={{
                                marginLeft: -40,
                                marginTop: device === DEVICE_MOBILE ? 23 : 16,
                                height: 20,
                                width: 20
                              }}
                            />
                          )}
                        {isFieldDisabled &&
                          CARD_SUPPORTED_ROUTING_CODE.includes(
                            this.props.formValues.routing_config_type
                          ) &&
                          !key.hideIcon &&
                          key.value_field_name !== 'card_issuer_name' && (
                            <EditText
                              src={EDIT_ICON}
                              alt="edit-btn"
                              onClick={this.enableCardEdit}
                            />
                          )}
                      </div>
                    ) : (
                      <Field
                        name={key['value_field_name']}
                        type="text"
                        className={'input form-flow disable_border'}
                        component={toggleFeature ? OutlinedTextFields : RenderTextField}
                        validate={isCardNumberUpdated ? validationArray : []}
                        disabled={isFieldDisabled}
                        placeholder={key.label}
                        isEditable={true}
                        onBlur={() => {
                          if (
                            key.value_field_name === 'card_number' &&
                            this.props.formValues.card_type === 'GEO_SWIFT_CARD'
                          ) {
                            this.emptyCardIssuerName();
                          }
                        }}
                        showErrorIcon={true}
                        isVisaCardEditCase={
                          isFieldDisabled &&
                          key['value_field_name'] === 'card_number' &&
                          this.props.formValues.routing_config_type === 'VISA_DEBIT_CARD'
                        }
                        normalize={(() => {
                          let { validation } = key;
                          if (validation) {
                            let { exact, max } = validation;
                            return r_maxLength(exact || max || 50);
                          }
                          return r_maxLength(50);
                        })()}
                      />
                    )}
                    {toggleFeature && this.props.formValues.card_type === 'VISA_DEBIT_CARD' && (
                      <div className="visaImages">
                        {isFieldDisabled &&
                          key.value_field_name === 'card_number' &&
                          this.props.formValues.routing_config_type === 'VISA_DEBIT_CARD' && (
                            <VisaImageActual
                              src={VISA_SVG_ICON}
                              style={{
                                height: '12px',
                                width: '36px',
                                marginTop: '5px',
                                marginLeft: `${window.innerWidth <= 1080 ? '-50px' : 0}`
                              }}
                            />
                          )}
                        {key.value_field_name === 'card_number' &&
                          !errors['card_number'] &&
                          show_visa_icon && (
                            <VisaImageActual
                              src={VISA_SVG_ICON}
                              style={{
                                width: '34px',
                                height: '19px',
                                marginRight: '10px'
                              }}
                            />
                          )}
                        {key.value_field_name === 'card_number' &&
                          !errors['card_number'] &&
                          fast_fund_message && (
                            <FastFundImageActual src={CORRECT_ICON} style={{ width: '20px' }} />
                          )}
                      </div>
                    )}
                    {!toggleFeature &&
                      isFieldDisabled &&
                      CARD_SUPPORTED_ROUTING_CODE.includes(
                        this.props.formValues.routing_config_type
                      ) &&
                      !key.hideIcon &&
                      key.value_field_name !== 'card_issuer_name' && (
                        <VisaImageActual
                          src={EDIT_ICON_MULTI_TXN_ICON}
                          alt="edit-btn"
                          style={{
                            marginRight: 0,
                            marginTop: 36,
                            height: 25
                          }}
                          onClick={this.enableCardEdit}
                        />
                      )}
                    {!toggleFeature &&
                      key.value_field_name === 'card_number' &&
                      !errors['card_number'] &&
                      show_visa_icon && (
                        <VisaImageActual
                          src={VISA_ICON}
                          style={{ marginTop: 44, paddingRight: 5 }}
                        />
                      )}
                    {!toggleFeature &&
                      key.value_field_name === 'card_number' &&
                      !errors['card_number'] &&
                      fast_fund_message &&
                      fastFundsIndicator === 'Y' && (
                        <FastFundImageActual
                          style={{ marginTop: 39, height: 20, width: 20 }}
                          src={STOPWATCH_ICON}
                        />
                      )}
                    {key.value_field_name === 'card_number' &&
                      !errors['card_number'] &&
                      fast_fund_message &&
                      !toggleFeature && (
                        <FastFundImageActual
                          src={CORRECT_ICON}
                          style={{ marginTop: 39, height: 20, width: 20 }}
                        />
                      )}
                  </FieldContainerActual>
                  {key.value_field_name === 'card_number' &&
                    !errors['card_number'] &&
                    fast_fund_message && (
                      <CardMessageContainerActual
                        id="card_success_message"
                        $isSingleRowField={this.props.isSingleRowField}
                      >
                        {fast_fund_message ? fast_fund_message : null}
                      </CardMessageContainerActual>
                    )}
                </Grid.Column>
              );
            }
            default:
              break;
          }
        }
      });
      return debitCardRenderHtml;
    }
  };

  resetFormFields() {
    let { debitRenderObject, isCardNumberUpdated, isDebitCardChecked } = this.state;
    const { isPartiallyEditable, isCompleteEditable } = this.props;
    if (debitRenderObject) {
      debitRenderObject = debitRenderObject.map((item) => {
        let valueFieldName = item.value_field_name;
        if (isCardNumberUpdated !== false) {
          this.props.dispatch(change(this.props.formName, valueFieldName, ''));
          this.props.dispatch(untouch(this.props.formName, valueFieldName, ''));
        }
        if (
          !isDebitCardChecked &&
          (isPartiallyEditable || isCompleteEditable) &&
          this.state[`${valueFieldName}_backup`] &&
          valueFieldName === 'card_number'
        ) {
          this.setState(
            {
              isCardNumberUpdated: false
            },
            () => this.props.setCardNumberUpdate(false)
          );
          this.props.dispatch(change(this.props.formName, 'is_card_number_updated', false));
        }
        if (
          !isDebitCardChecked &&
          (isPartiallyEditable || isCompleteEditable) &&
          this.state[`${valueFieldName}_backup`]
        ) {
          this.props.dispatch(
            change(this.props.formName, valueFieldName, this.state[`${valueFieldName}_backup`])
          );
          this.props.dispatch(
            untouch(this.props.formName, valueFieldName, this.state[`${valueFieldName}_backup`])
          );
          return { ...item, disabled: true };
        }
        return item;
      });
      this.setState({
        debitRenderObject
      });
    }
    this.props.dispatch(change(this.props.formName, 'details_selected', ''));
  }

  emptyFormFields = (valueFieldName) => {
    this.props.dispatch(change(this.props.formName, valueFieldName, null));
    this.props.dispatch(untouch(this.props.formName, valueFieldName, null));
  };
  clearFormFields = () => {
    this.resetFormFields();
    this.emptyFormFields('bank_card_validations');
    this.emptyFormFields('bank_name');
    this.emptyFormFields('show_visa_icon');
    this.emptyFormFields('fast_fund_message');
    this.emptyFormFields('beneficiary_bank_address_info');
    this.emptyFormFields('card_type');
  };
  isSaveDisabled = () => {
    const { debitRenderObject, isBankChecked, renderObject } = this.state;
    const { formValues } = this.props;
    let isEmpty = false;
    if (isBankChecked && renderObject) {
      renderObject.forEach((item) => {
        if (!formValues[item.value_field_name]) isEmpty = true;
      });
    } else if (!isBankChecked && debitRenderObject) {
      debitRenderObject.forEach((item) => {
        if (!formValues[item.value_field_name]) isEmpty = true;
      });
    }
    return isEmpty;
  };
  saveDetails = async (existingItem, existingItemIndex) => {
    const { debitRenderObject, renderObject } = this.state;
    const { formValues, handleError, activateLoader, disableLoader, isMultiBene, loadBene } =
      this.props;
    const {
      details_selected,
      beneficiary_id,
      beneficiary_routing_config_id_bank,
      beneficiary_routing_config_id_debit
    } = formValues;
    let otherProps = {},
      response = null;
    try {
      activateLoader();
      if (details_selected === 'card') {
        debitRenderObject.forEach((item) => {
          let valueFieldName = item.value_field_name;
          otherProps[valueFieldName] = formValues[valueFieldName];
        });
        const encriptedCardData = encryptDataWithSignature(otherProps.card_number);
        otherProps.card_number = encriptedCardData.encryptedData;
        otherProps.signature = encriptedCardData.signature;
        otherProps['beneficiary_routing_config_id'] = beneficiary_routing_config_id_debit;
        response = await this.props.saveNewBenificiary(beneficiary_id, otherProps);
      } else if (details_selected === 'bank') {
        renderObject.forEach((item) => {
          let valueFieldName = item.value_field_name;
          otherProps[valueFieldName] = formValues[valueFieldName];
        });
        otherProps['beneficiary_routing_config_id'] = beneficiary_routing_config_id_bank;
        response = await this.props.saveNewBenificiary(beneficiary_id, otherProps);
      }
      if (response && response.data && response.data.success) {
        let new_bene_id = response.data.data.beneficiary_id;
        if (existingItem) {
          const newBeneficeryData = await this.props.getBeneficiaryByID(new_bene_id);
          if (newBeneficeryData.data && newBeneficeryData.data.success) {
            let newBeneficiaryDetails = newBeneficeryData.data.data;
            const newItem = {
              ...existingItem,
              ...{ beneficiary_id: new_bene_id }
            };
            newItem['payload']['beneficiary_id'] = new_bene_id;
            newItem['beneficiaryDataToBeShown']['card_details'] = {
              card_no: newBeneficiaryDetails.card_number,
              card_expiry: newBeneficiaryDetails.card_expiry_date,
              card_holder_name: newBeneficiaryDetails.card_holder_name,
              card_issuer_name: newBeneficiaryDetails.card_issuer_name
            };
            newItem['beneficiaryDataToBeShown']['bank_details'] = {
              account_no: newBeneficiaryDetails.bank_account_number,
              bank: newBeneficiaryDetails.bank_name
            };
            await this.props.replaceRecipientListItem(existingItemIndex, newItem);
          }
        }
        this.resetFormFields();
        this.props.dispatch(change(this.props.formName, 'show_bank_details_block', false));
        !isMultiBene && (await this.props.refreshParent());
        this.props.dispatch(change(this.props.formName, 'beneficiary_id', new_bene_id));
        isMultiBene && this.props.onClose();
        loadBene && isMultiBene && loadBene();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      handleError(error);
    }
    disableLoader();
  };

  render() {
    const { isBlock, isPaymentMethod, isMultiBene, featureState, countryCode } = this.props;
    const toggleFeature = get(featureState, 'toggleFeature', false);
    const { debitCardFields, isBankChecked, isDebitCardChecked } = this.state;
    const isDisbled = this.isSaveDisabled();
    return toggleFeature ? (
      <Grid.Row
        className={
          'form-row bank-details' +
          (isBlock ? '' : ' zero-top-padding') +
          (isPaymentMethod ? ' bank-details-container' : '')
        }
      >
        {isBlock && !isPaymentMethod && !this.props.isNewBeneAddFlow && (
          <Grid.Column width={16}>
            {debitCardFields ? (
              <Title className="form-flow-header">{'Recipient’s Receiving Options'}</Title>
            ) : (
              <Title className="form-flow-header">{'Bank details'}</Title>
            )}
          </Grid.Column>
        )}
        {get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
          <LabelText
            $isSingleRowField={this.props.isSingleRowField}
            style={{
              fontSize: 14,
              paddingLeft: isMultiBene ? 50 : 0,
              paddingTop: isMultiBene ? 25 : 0
            }}
          >{`Please provide your recipient’s VISA debit card details`}</LabelText>
        )}
        {isPaymentMethod && (
          <div className={isMultiBene ? 'bank-details-holder-no-border' : 'bank-details-holder'}>
            <div
              className={'bank-details-section'}
              style={debitCardFields ? { marginTop: 20 } : { marginTop: 0 }}
            >
              {<FragementNew>{this.renderDebitCard()}</FragementNew>}
              {get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
                <StyledGrid width={16} className="align-items-center">
                  <TNCText style={{ fontSize: 14, paddingTop: isBankChecked ? 20 : 0 }}>
                    By proceeding, you agree to all
                    <Link to={VISA_TNC_LINK} target={'_blank'} style={{ color: '#009adf' }}>
                      Terms & Conditions
                    </Link>
                  </TNCText>
                </StyledGrid>
              )}

              <ButtonContainer marginTop={!isMultiBene ? 10 : 50}>
                <SaveButton
                  type="button"
                  bgColor={'#e8e8e8'}
                  color={'#9b9b9b'}
                  onClick={() => {
                    this.clearFormFields();
                    this.props.closeBankDetailsBlock();
                  }}
                >
                  Cancel
                </SaveButton>
                <SaveButton
                  type="button"
                  disabled={isDisbled}
                  onClick={() =>
                    this.saveDetails(this.props.existingItem, this.props.existingItemIndex)
                  }
                >
                  Save Details
                </SaveButton>
              </ButtonContainer>
            </div>
          </div>
        )}
        {!isPaymentMethod && <FragementNew>{this.renderDebitCard()}</FragementNew>}
        {!isPaymentMethod && get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
          <Grid.Column width={16} className="align-items-center">
            <TNCText
              isSingleRowField={this.props.isSingleRowField}
              isNewBeneAddFlow={this.props.isNewBeneAddFlow}
              style={{ fontSize: 12, paddingTop: 0 }}
            >
              By proceeding, you agree to all{' '}
              <Link to={VISA_TNC_LINK} target={'_blank'} style={{ color: '#009adf' }}>
                Terms & Conditions
              </Link>
            </TNCText>
            <FAQText isSingleRowField={this.props.isSingleRowField}>
              Please check our
              <a
                href={VISA_FAQ_LINKS[countryCode || 'SG']}
                target={'_blank'}
                rel="noopener noreferrer"
                style={{ color: '#009adf' }}
              >
                {' '}
                FAQs
              </a>{' '}
              {`for more details.`}
            </FAQText>
          </Grid.Column>
        )}
      </Grid.Row>
    ) : (
      <Grid.Row
        className={
          'form-row bank-details' +
          (isBlock ? '' : ' zero-top-padding') +
          (isPaymentMethod ? ' bank-details-container' : '')
        }
      >
        {isBlock && !isPaymentMethod && (
          <Grid.Column width={16}>
            {debitCardFields ? (
              <div className="form-flow-header">
                {'How would you like recipient to receive money?'}
              </div>
            ) : (
              <div className="form-flow-header">{'Bank details '}</div>
            )}
          </Grid.Column>
        )}
        {get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
          <LabelTextNonSG
            style={{
              marginLeft: !isPaymentMethod ? 20 : 0,
              fontSize: !isPaymentMethod ? 12 : 14,
              paddingLeft: isMultiBene ? 50 : 0,
              paddingTop: isMultiBene ? 25 : 0
            }}
          >
            {`Please enter your recipient’s VISA debit card details for a quick way to transfer funds. Please check our `}
            <a
              href={VISA_FAQ_LINKS[countryCode || 'SG']}
              target={'_blank'}
              rel="noopener noreferrer"
              style={{ color: '#009adf' }}
            >
              {' '}
              FAQs
            </a>{' '}
            {`for more details.`}
          </LabelTextNonSG>
        )}
        {isPaymentMethod && (
          <div className={isMultiBene ? 'bank-details-holder-no-border' : 'bank-details-holder'}>
            <div
              className={'bank-details-section'}
              style={debitCardFields && !isMultiBene ? { marginTop: 20 } : { marginTop: 0 }}
            >
              {this.renderDebitCard()}
              {!isBankChecked &&
                get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
                  <StyledGridNonSG width={16}>
                    <LabelTextNonSG
                      style={{
                        fontSize: 14,
                        paddingTop: isBankChecked ? 20 : 0
                      }}
                    >
                      By proceeding, you agree to all{' '}
                      <Link to={VISA_TNC_LINK} target={'_blank'} style={{ color: '#009adf' }}>
                        Terms & Conditions
                      </Link>
                    </LabelTextNonSG>
                  </StyledGridNonSG>
                )}

              <ButtonContainerNonSG marginTop={!isMultiBene ? 10 : 50}>
                <SaveButtonNonSG
                  type="button"
                  bgColor={'#e8e8e8'}
                  color={'#9b9b9b'}
                  onClick={() => {
                    this.clearFormFields();
                    this.props.closeBankDetailsBlock();
                  }}
                >
                  Cancel
                </SaveButtonNonSG>
                <SaveButtonNonSG
                  type="button"
                  disabled={isDisbled}
                  onClick={() =>
                    this.saveDetails(this.props.existingItem, this.props.existingItemIndex)
                  }
                >
                  Save Details
                </SaveButtonNonSG>
              </ButtonContainerNonSG>
            </div>
          </div>
        )}
        {!isPaymentMethod && this.renderDebitCard()}
        {isDebitCardChecked &&
          !isPaymentMethod &&
          get(this.props, 'formValues.card_type', '') === 'VISA_DEBIT_CARD' && (
            <Grid.Column width={16}>
              <LabelTextNonSG style={{ fontSize: 14, paddingTop: 20 }}>
                By proceeding, you agree to all{' '}
                <Link to={VISA_TNC_LINK} target={'_blank'} style={{ color: '#009adf' }}>
                  Terms & Conditions
                </Link>
              </LabelTextNonSG>
            </Grid.Column>
          )}
      </Grid.Row>
    );
  }
}

CardDetailsBlock.propTypes = {
  fields: PropTypes.object,
  show_loader: PropTypes.bool,
  formValues: PropTypes.any,
  renderFields: PropTypes.any,

  dispatch: PropTypes.func,
  isBlock: PropTypes.bool,
  currency_code: PropTypes.string,
  formName: PropTypes.string,
  getBankFields: PropTypes.func,
  countryCode: PropTypes.any,
  bank_account_country: PropTypes.any,
  debitCardFields: PropTypes.any,
  bank_validations: PropTypes.any,
  debit_validations: PropTypes.any,
  isPaymentMethod: PropTypes.any,
  handleError: PropTypes.any,
  activateLoader: PropTypes.any,
  disableLoader: PropTypes.any,
  isMultiBene: PropTypes.any,
  saveNewBenificiary: PropTypes.any,
  refreshParent: PropTypes.any,
  onClose: PropTypes.func,
  existingItem: PropTypes.any,
  existingItemIndex: PropTypes.any,
  getBeneficiaryByID: PropTypes.any,
  replaceRecipientListItem: PropTypes.any,
  isPartiallyEditable: PropTypes.bool,
  isCompleteEditable: PropTypes.bool,
  errors: PropTypes.any,
  closeBankDetailsBlock: PropTypes.any,
  loadBene: PropTypes.any,
  fastFundsIndicator: PropTypes.string,
  setCardNumberUpdate: PropTypes.func,
  onTransferMoneyOptionChange: PropTypes.func,
  beneDetails: PropTypes.any,
  remitterCountryCode: PropTypes.any,
  country_code: PropTypes.string,
  featureState: PropTypes.any,
  device: PropTypes.string,
  isNewBeneAddFlow: PropTypes.bool,
  isSingleRowField: PropTypes.bool
};

function mapStateToProps(store) {
  const {
    rootReducer: {
      bankValidationsReducer: {
        asyncResponse: { fastFundsIndicator = '' }
      },
      userDataReducer: { beneDetails, toggleFeature: featureState },
      userStatusReducer: { country_code: remitterCountryCode },
      uiTriggerState: { device }
    }
  } = store;

  return {
    fastFundsIndicator,
    beneDetails,
    remitterCountryCode,
    featureState,
    device
  };
}
export default connect(mapStateToProps, {
  saveNewBenificiary,
  getBeneficiaryByID,
  replaceRecipientListItem,
  setCardNumberUpdate
})(CardDetailsBlock);
